import * as React from "react";
import styles from "./Card.module.css";

export default function CustomCard({
  title,
  description,
  body,
  link,
}) 
{
  return (
    <li className={styles.projectItem}>
      <h3>{title}</h3>
      <p>{description}</p>
      <p>{body}</p>
      {link ? (
        <p>
          <a href={link} target="_blank" rel="noreferrer">
            Learn more
          </a>
        </p>
      ) : null}
    </li>
  );
}
